import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';
import Lightbox from '../ui/Lightbox'; // Importe o novo componente

const GallerySection = ({ settings }) => {
    const [images, setImages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isLightboxOpen, setIsLightboxOpen] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);

    useEffect(() => {
        const fetchImages = async () => {
            const q = query(collection(db, "gallery"), orderBy("createdAt", "desc"));
            const querySnapshot = await getDocs(q);
            setImages(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setIsLoading(false);
        };
        fetchImages();
    }, []);

    if (!settings) {
        return <section id="galeria" className="py-20 md:py-32"></section>;
    }

    const title = settings.galleryTitle || 'A NOSSA GALERIA';

    const openLightbox = (index) => {
        setSelectedImageIndex(index);
        setIsLightboxOpen(true);
    };

    const closeLightbox = () => {
        setIsLightboxOpen(false);
    };

    return (
        <>
            <section id="galeria" className="py-20 md:py-32">
                <div className="container mx-auto px-6">
                    <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-primary">{title}</h2>
                    {isLoading ? (
                        <p className="text-center">A carregar galeria...</p>
                    ) : (
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                            {images.map((image, index) => (
                                <div 
                                    key={image.id} 
                                    className="group relative overflow-hidden rounded-lg shadow-lg cursor-pointer"
                                    onClick={() => openLightbox(index)}
                                >
                                    <img 
                                        src={image.url} 
                                        alt={`Imagem da galeria da barbearia - ${title} ${index + 1}`} // Alt tag para SEO
                                        className="w-full h-full object-cover aspect-square transform group-hover:scale-110 transition-transform duration-500" 
                                    />
                                    <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-all duration-300"></div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>

            {isLightboxOpen && (
                <Lightbox 
                    images={images}
                    startIndex={selectedImageIndex}
                    onClose={closeLightbox}
                />
            )}
        </>
    );
};

export default GallerySection;
